<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">メインメニュー</a>
      </li>
      <li class="active">スマートフォン一覧</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace phoneId" checked="checked" @click="addRomoveScorp('phoneId', 'phoneId')">
        <span class="lbl">スマートフォンID</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace model" checked="checked" @click="addRomoveScorp('model', 'model')">
        <span class="lbl">端末名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button v-if="selectedPhoneId.length>0" class="btn-cusstom black-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたスマートフォンを無効化</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_id" type="checkbox" class="ace" disabled checked>
                      <span class="lbl"> スマートフォンID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_model" type="checkbox" @click="ShowHideColumn" class="ace" checked value="model" v-model="checkedColumnNames">
                      <span class="lbl">端末名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_userid" type="checkbox" @click="ShowHideColumn" class="ace" checked value="userId" v-model="checkedColumnNames">
                      <span class="lbl">ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_status" type="checkbox" class="ace" @click="ShowHideColumn" checked value="status" v-model="checkedColumnNames">
                      <span class="lbl">ステータス</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_registered" type="checkbox" class="ace" @click="ShowHideColumn" checked value="registered" v-model="checkedColumnNames">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="phone_updated" type="checkbox" class="ace" @click="ShowHideColumn" checked value="updated" v-model="checkedColumnNames">
                      <span class="lbl">更新日</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                  <div class="checkbox table_items">
                    <label>
                      <input type="checkbox" class="ace" checked v-model="notLoadAllData" @click="reLoadData()">
                      <span class="lbl">有効なデーターのみ表示</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="phone_id" class="phone_id sorting" @click="sort('phoneId', 'phone_id')">スマートフォンID</th>
              <th id="phone_model" class="phone_model sorting" @click="sort('model', 'phone_model')" v-bind:class="{'none': checkColumnShowHide('model')}">端末名</th>
              <th id="phone_userid" class="phone_userid sorting" @click="sort('userId', 'phone_userid')" v-bind:class="{'none': checkColumnShowHide('userId')}">ユーザーID</th>
              <th id="phone_status" class="phone_status sorting center" @click="sort('status', 'phone_status')" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th id="phone_registered" class="center phone_registered sorting" @click="sort('registered', 'phone_registered')" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th id="phone_updated" class="center phone_updated sorting" @click="sort('updated', 'phone_updated')" v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr v-bind:class="{'selected': rowSelected(item.phoneId)}" :id="item.phoneId">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.phoneId" v-model="selectedPhoneId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="phone_id" @click="showdetail">
                {{item.phoneId}}
              </td>
              <td class="phone_model" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('model')}">
                {{item.model}}
              </td>
              <td class="phone_userid" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userId')}">
                {{item.userId}}
              </td>
              <td v-if="checkSpecilCell(item.status)" class="center phone_status specil-cell" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">{{item.status}}</td>
              <td v-else class="center phone_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">{{item.status}}</td>
              <td class="center phone_registered" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">{{ converDate(item.registered) }}</td>
              <td class="center phone_updated" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">{{ converDate(item.updated) }}</td>
            </tr>
            <tr class="detail-row">
              <td v-bind:colspan ="columnCount">
                <app-phone-detail v-bind:item="item" v-bind:userId="item.userId"></app-phone-detail>
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>スマートフォンID</th>
              <th>端末名</th>
              <th>ステータス</th>
              <th>登録日</th>
              <th>更新日</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="6">{{message}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">スマートフォンを無効化</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたスマートフォンを一括無効化します、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successPhone>0">{{countPhone}}件中{{successPhone}}件を無効化しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">無効化失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="updateAllStatus()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <a href="javascript:void(0)" class="float" id="menu-share">
    <i class="fa fa-plus my-float"></i>
  </a>
  <ul class="add_btn_list">
    <li>
      <router-link :to="{ name: 'phoneimport'}" class="adduser">
        <i class="ace-icon glyphicon glyphicon-upload my-float"></i>
      </router-link>
      <div class="label-container">
        <div class="label-text">CSVインポートでスマートフォン登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
  </ul>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
import PhoneDetail from './PhoneDetail.vue'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      message: 'データー取得中',
      checkedColumnNames: [
        'model',
        'userId',
        'status',
        'registered',
        'updated'
      ],
      notLoadAllData: true,
      scorp: ['phoneId', 'model', 'userId'],
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      selected: 100,
      selectedPhoneId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successPhone: 0,
      errorName: '',
      columnCount: 0,
      exeCount: 0,
      percent: 0,
      countPhone: 0
    }
  },
  components: {
    appPhoneDetail: PhoneDetail
  },
  watch: {
    'progress': 'checkProgress',
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countPhone) {
        vm.updateStatus(this.selectedPhoneId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countPhone) {
        this.exeCount = 0
        this.getList()
      }
    }
  },
  created () {
    if (typeof localStorage.pageSizePhone === 'undefined') {
      localStorage.setItem('pageSizePhone', 100)
      this.selected = localStorage.pageSizePhone
    } else {
      this.selected = localStorage.pageSizePhone
    }
    if (typeof localStorage.phoneSortKey === 'undefined') {
      localStorage.setItem('phoneSortKey', 'userId')
    }
    if (typeof localStorage.phoneSortName === 'undefined') {
      localStorage.setItem('phoneSortName', 'desc')
    }
    if (typeof localStorage.notLoadAllData === 'undefined') {
      localStorage.setItem('notLoadAllData', 'yes')
    }
    if (typeof localStorage.checkedPhoneList === 'undefined') {
      localStorage.setItem('checkedPhoneList', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedPhoneList.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    this.columnCount = this.checkedColumnNames.length + 2
    if (localStorage.notLoadAllData === 'yes') {
      this.notLoadAllData = true
    } else {
      this.notLoadAllData = false
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        return this.list ? this.selectedPhoneId.length === this.list.length : false
      },
      set: function (value) {
        var selectedPhoneId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedPhoneId.push(item.phoneId)
          })
        }
        this.selectedPhoneId = selectedPhoneId
      }
    }
  },
  methods: {
    viewUser (id) {
      let routeData = this.$router.resolve({name: 'useredit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    checkSpecilCell (data) {
      if (data === '申請中') {
        return true
      } else {
        return false
      }
    },
    reLoadData () {
      if (localStorage.notLoadAllData === 'yes') {
        localStorage.setItem('notLoadAllData', 'no')
      } else {
        localStorage.setItem('notLoadAllData', 'yes')
      }
      this.pages = 0
      this.listQuery.currPage = 1
      this.getList()
    },
    updateChecked () {
      localStorage.setItem('checkedPhoneList', this.checkedColumnNames)
      this.columnCount = this.checkedColumnNames.length + 2
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedPhoneList.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    // スマートフォン詳細を開く
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
    },
    // 実行状態チェック
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedPhoneId = []
      }
    },
    // チェックしたスマートフォンを無効化すり前にリセット
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたスマートフォンを一括無効化します、よろしいですか？')
      this.progress = 0
      this.success = false
      this.exeCount = 0
      this.isDisabled = false
      this.errorMessage = []
      this.successPhone = 0
      this.countPhone = 0
    },
    // 行にチェックする
    rowSelected (phoneId) {
      if (jQuery.inArray(phoneId, this.selectedPhoneId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // チェックしたユーザーを無効化
    updateStatus (phoneId, percent, i) {
      var vm = this
      this.$http.put(Config.PHONES_LIST_API + '/' + encodeURIComponent(phoneId), {isValid: false})
        .then(response => {
          vm.progress += percent
          vm.successPhone++
          this.exeCount++
        })
        .catch((error) => {
          this.progress += percent
          this.exeCount++
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'スマートフォンの編集権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = phoneId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
        })
    },
    updateAllStatus () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedPhoneId.length > 0) {
        this.countPhone = this.selectedPhoneId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedPhoneId.length)
        vm.updateStatus(this.selectedPhoneId[0], vm.percent, 0)
      } else {
        alert('少なくてもスマートフォンを１つ選んでください。')
      }
    },
    // 検索項目チェンジ
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    resetView () {
      $('#simple-table').find('tr.detail-row').removeClass('open')
      $('div.panel-collapse').removeClass('in')
      $('a.accordion-toggle').addClass('collapsed')
      $('a.accordion-toggle i').addClass('fa-angle-right')
      $('a.accordion-toggle i').removeClass('fa-angle-down')
    },
    // 検索
    search () {
      var apiLink = ''
      this.errorMessageLogs = ''
      this.loading = true
      if (this.scorp.length > 0) {
        this.resetView()
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        if (localStorage.notLoadAllData === 'yes') {
          apiLink = Config.PHONES_LIST_API + '?limit=' + localStorage.pageSizePhone + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.phoneSortName + ':' + localStorage.phoneSortKey + '&isValid=true'
        } else {
          apiLink = Config.PHONES_LIST_API + '?limit=' + localStorage.pageSizePhone + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.phoneSortName + ':' + localStorage.phoneSortKey
        }
        this.$http.get(apiLink)
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePhone)
              this.list = response.body.phones
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.message = '該当するデーターがありません。'
            }
            console.log(response)
          })
          .catch((error) => {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('phoneSortName', 'desc')
        localStorage.setItem('phoneSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('phoneSortName', 'asc')
        localStorage.setItem('phoneSortKey', sortkey)
      }
      this.getList()
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizePhone', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    // ページネーションチェンジ
    handleCurrentChange (val) {
      this.selectedPhoneId = []
      this.listQuery.currPage = val
      this.getList()
      $('#simple-table').find('tr.detail-row').removeClass('open')
      window.scrollTo(0, 0)
    },
    // コラム表示する
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    // スマートフォン一覧
    getList () {
      var apiLink = ''
      this.errorMessageLogs = ''
      this.loading = true
      this.resetView()
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      if (localStorage.notLoadAllData === 'yes') {
        apiLink = Config.PHONES_LIST_API + '?limit=' + localStorage.pageSizePhone + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.phoneSortName + ':' + localStorage.phoneSortKey + '&isValid=true'
      } else {
        apiLink = Config.PHONES_LIST_API + '?limit=' + localStorage.pageSizePhone + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.phoneSortName + ':' + localStorage.phoneSortKey
      }
      this.$http.get(apiLink)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePhone)
            this.list = response.body.phones
            console.log(response)
          } else {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
          }
        })
        .catch(error => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/phone/PhoneList.vue